import { createFileRoute } from "@tanstack/react-router";
import { ActivitiesPage } from "@/modules/activity/presentation/pages/ActivitiesPage";

export const Route = createFileRoute("/_authenticated/move_/activities")({
  component: ActivitiesPage,
});
